function titleCaseToken(token: string): string {
    if (/^r&b$/i.test(token)) return 'R&B';
    if (token.includes('-')) {
        return token.split('-').map((part) => titleCaseToken(part)).join('-');
    }
    if (token.includes('&')) {
        return token.split('&').map((part) => titleCaseToken(part)).join('&');
    }
    if (!token) return token;
    return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
}

/** Title-case a genre for display. The stored string is left unchanged. */
export function formatGenreLabel(value: string): string {
    const trimmed = value.trim().replace(/\s+/g, ' ');
    return trimmed.split(' ').map((word) => titleCaseToken(word)).join(' ');
}

export function formatGenreList(genres: string[]): string {
    return genres.map(formatGenreLabel).filter(Boolean).join(', ');
}
